import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogStyle } from '@app/app/shared/helpers/dialog/v3-dialog.service';
import { StyleguideModule } from '@app/app/shared/styleguide/styleguide.module';

export interface ConfirmationPopupData {
  title: string | HTMLElement;
  message: string;
  confirmButtonText: string;
  cancelButtonText?: string;
  confirmButtonType?: 'primary' | 'secondary' | 'secondary-neutral' | 'primary-alert';
  cancelButtonType?: 'primary' | 'secondary' | 'secondary-neutral';
  style?: ConfirmDialogStyle;
  hideCancelButton?: boolean;
}

export interface ConfirmationPopupResult {
  confirmed: boolean;
}

/**
 * NOTE: Preferred way to open a confirmation dialog is via `V3DialogService.showConfirmDialog()`:
 * @see V3DialogService.showConfirmDialog (src/app/shared/helpers/dialog/v3-dialog.service.ts)
 */
@Component({
  selector: 'ptl-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StyleguideModule],
})
export class ConfirmationPopupComponent {
  dialogRef = inject(MatDialogRef<ConfirmationPopupComponent>);
  data: ConfirmationPopupData = inject(MAT_DIALOG_DATA);

  onCancel(): void {
    this.dialogRef.close({ confirmed: false } as ConfirmationPopupResult);
  }

  onConfirm(): void {
    this.dialogRef.close({ confirmed: true } as ConfirmationPopupResult);
  }
}
